<template>
  <!-- 建档 -->
  <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '600px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <Detail ref="detailRef" />
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('审核意见')" prop="audit">
                <a-radio-group v-model="model.audit">
                  <a-radio :value="1">{{ $t('通过') }}</a-radio>
                  <a-radio :value="0">{{ $t('驳回') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark1">
                <a-textarea v-model="model.remark1" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <template v-if="model.audit == 1">
            <a-divider orientation="left">
                {{ $t('表具信息') }}
            </a-divider>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('表编号')" prop="meterId" :hasFeedback="true">
                  <a-input v-model="model.meterId" :placeholder="$t('请输入表编号')" :readOnly="true" @click="setMeterInfo()"></a-input>
                </a-form-model-item>
              </a-col>
              <!-- <a-col :span="8">
                <a-form-model-item label="水表厂商" prop="mtComName">
                  <a-input v-model="model.mtComName" placeholder="请输入水表厂商" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="表类型" prop="mtCode">
                  <a-select v-model="model.mtCode" placeholder="请选择表类型" :disabled="disableSubmit">
                    <a-select-option v-for="(data,index) in meterTypeList" :key="data.id" :value="data.id">
                      <a-tooltip>
                        <template slot="title">
                          {{data.mtName}}
                        </template>
                        {{data.mtName}}
                      </a-tooltip>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="册号" prop="mtVolumeNo">
                  <a-input v-model="model.mtVolumeNo" placeholder="请输入册号" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              </a-row>
              <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item label="表编号" prop="meterId" :hasFeedback="true">
                  <a-input v-model="model.meterId" placeholder="请输入表编号" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="表口径" prop="mtCaliber">
                  <a-select v-model="model.mtCaliber" placeholder="请选择表口径" :disabled="disableSubmit">
                    <a-select-option v-for="(data,index) in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                      DN{{data.mtCaliber}}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="水表用途" prop="mtUseType">
                  <j-dict-select-tag :disabled="disableSubmit" v-model="model.mtUseType" placeholder="请选择水表用途"
                    dictCode="mtUseType" style="width:100%" />
                </a-form-model-item>
              </a-col>
              </a-row>
              <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item label="运营商" prop="mtIotType">
                  <j-dict-select-tag :disabled="disableSubmit||model.mtState === 1" v-model="model.mtIotType" 
                    placeholder="请选择运营商" dictCode="mtIotType" style="width:100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="IMEI号" prop="mtImei">
                  <a-input :disabled="disableSubmit" v-model="model.mtImei" placeholder="请输入IMEI号"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="SIM卡号" prop="mtSim">
                  <a-input :disabled="disableSubmit" v-model="model.mtSim" placeholder="请输入SIM卡号"></a-input>
                </a-form-model-item>
              </a-col>
              </a-row>
              <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item label="是否带阀" prop="mtHasValve">
                  <j-dict-select-tag :disabled="disableSubmit" v-model="model.mtHasValve"
                    placeholder="请选择是否带阀" :showSearch="false" dictCode="yn" style="width:100%" />
                </a-form-model-item>
              </a-col> -->
              </a-row>
              <detail-list v-if="model.meterId">
                <detail-list-item :term="$t('水表厂商')">{{model.mtComName}}</detail-list-item>
                <detail-list-item :term="$t('表类型')">{{model.mtName}}</detail-list-item>
                <detail-list-item :term="$t('册号')">{{model.mtVolumeNo}}</detail-list-item>
                <detail-list-item :term="$t('表口径')">{{'DN'+model.mtCaliber}}</detail-list-item>
                <detail-list-item :term="$t('水表用途')">{{setValue('mtUseType',model.mtUseType)}}</detail-list-item>
                <detail-list-item :term="$t('运营商')">{{setValue('mtIotType',model.mtIotType)}}</detail-list-item>
                <detail-list-item :term="$t('IMEI号')">{{model.mtImei}}</detail-list-item>
                <detail-list-item :term="$t('SIM卡号')">{{model.mtSim}}</detail-list-item>
                <detail-list-item :term="$t('是否带阀')">{{setValue('yn',model.mtHasValve)}}</detail-list-item>
              </detail-list>
              <a-divider orientation="left">
                  {{ $t('地址信息') }}
              </a-divider>
              <a-row :gutter="24">
              <a-col :span="8">
                  <a-form-model-item :label="$t('区域名称')" prop="userAreaName">
                      <a-input v-model="model.userAreaName" :placeholder="$t('请选择区域')" :readOnly="true"  @click="setModalVisible()"></a-input>
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                  <a-form-model-item :label="$t('用户地址')" prop="userAddr">
                      <a-input v-model="model.userAddr" :placeholder="$t('请输入用户地址')"></a-input>
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                  <a-form-model-item :label="$t('表安装地址')">
                      <a-input v-model="model.userMeterAddr" :placeholder="$t('请输入水表安装地址')"></a-input>
                  </a-form-model-item>
              </a-col>
              </a-row>
              <a-row :gutter="24">      
              <a-col :span="8">
                  <a-form-model-item :label="$t('安装经度')">
                      <a-input-number v-model="model.userMeterLng" :placeholder="$t('请输入水表安装经度')" style="width:100%"/>
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                  <a-form-model-item :label="$t('安装纬度')">
                      <a-input-number v-model="model.userMeterLat" :placeholder="$t('请输入水表安装纬度')" style="width:100%"/>
                  </a-form-model-item>
              </a-col>
              </a-row>
              <a-divider orientation="left">
                  {{ $t('用户信息') }}
              </a-divider>
              <a-row :gutter="24">
              <a-col :span="8">
                  <a-form-model-item :label="$t('用户编号')" prop="userId" :hasFeedback="true">
                      <a-input v-model="model.userId" :placeholder="$t('请输入用户编号')"></a-input>
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                  <a-form-model-item :label="$t('用户姓名')" prop="userName">
                      <a-input v-model="model.userName" :placeholder="$t('请输入用户姓名')"></a-input>
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                  <a-form-model-item :label="$t('手机号码')" prop="userPhone">
                      <a-input v-model="model.userPhone" :placeholder="$t('请输入用户手机号')"></a-input>
                  </a-form-model-item>
              </a-col>
              </a-row>
              <a-row :gutter="24">
              <a-col :span="8">
                  <a-form-model-item :label="$t('身份证号')" prop="userIdNumber">
                      <a-input v-model="model.userIdNumber" :placeholder="$t('请输入身份证号')"></a-input>
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                  <a-form-model-item :label="$t('用户类型')">
                      <a-select v-model="model.userTypeCode" :placeholder="$t('请选择用户类型')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                          <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                          {{data.utName}}
                          </a-select-option>
                      </a-select>
                  </a-form-model-item>
              </a-col>
              </a-row>
              <a-row :gutter="24">
              <a-col :span="24">
                  <a-form-model-item :label="$t('备注')" >
                      <a-textarea v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                  </a-form-model-item>
              </a-col>
              </a-row>
              <a-col :span="24">
                  <a-collapse>
                      <a-collapse-panel key="1" :header="$t('用户选填信息')" :forceRender="true">
                          <a-row :gutter="16">
                              <a-col :span="8">
                              <a-form-model-item :label="$t('营收编号')">
                                  <a-input v-model="model.userPayId" :placeholder="$t('请输入用户营收编号')"></a-input>
                              </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                              <a-form-model-item :label="$t('身份类型')" >
                                  <a-select  v-model="model.userIdType" :placeholder="$t('请选择身份类型')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                                  <a-select-option :value="1">
                                      {{ $t('自然人') }}
                                  </a-select-option>
                                  <a-select-option :value="0">
                                      {{ $t('企业') }}
                                  </a-select-option>
                                  </a-select>
                              </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                              <a-form-model-item :label="$t('不动产权号')">
                                  <a-input v-model="model.realPropertyRights" :placeholder="$t('请输入不动产权号')"></a-input>
                              </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                              <a-form-model-item :label="$t('小区名或村庄名')">
                                  <a-input v-model="model.userCommName" :placeholder="$t('请输入用户所在小区名或村庄名')"></a-input>
                              </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                              <a-form-model-item :label="$t('是否允许缴费')" >
                                  <j-dict-select-tag v-model="model.userPayState" :triggerChange="true" :showSearch="false" :placeholder="$t('请选择是否允许缴费')" dictCode="yn" style="width:100%"/>
                              </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                              <a-form-model-item :label="$t('优惠信息')">
                                  <j-dict-select-tag v-model="model.userFreeinfo" :triggerChange="true" :placeholder="$t('请选择水表用途')" dictCode="user_free_type" style="width:100%"/>
                              </a-form-model-item>
                              </a-col>
                          </a-row>
                      </a-collapse-panel>
                  </a-collapse>
              </a-col>
          </template>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <a-modal v-model="modal2Visible" :title="title2" centered :width="width" :maskClosable="false">
        <template slot="footer">
            <a-button key="close" @click="handleCancel">
            {{ $t('关闭') }}
            </a-button>
        </template>
        <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear :placeholder="$t('请输入区域名称')"/>
        <a-spin tip="Loading..." :spinning="areaLoading">
            <el-tree
                class="filter-tree"
                :data="areaTree"
                :props="defaultProps"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :check-on-click-node="true"
                :check-strictly="checkStrictly"
                :highlight-current="true"
                node-key="id"
                :current-node-key="currentNodeKey"
                :default-expanded-keys="iExpandedKeys"
                @node-click="nodeClick"
                ref="areaTree">
                </el-tree>
        </a-spin>
    </a-modal>
    <j-modal :title="$t('选择用户')" :width="1200" :visible="meterModalVisible" :maskClosable="false" @ok="handleOk1"
      @cancel="handleCancel1" :okText="$t('确定')" :cancelText="$t('关闭')">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <j-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表类型')">
                <a-select v-model="queryParam.mtCode" :placeholder="$t('请选择表类型')">
                  <a-select-option v-for="(data,index) in meterTypeList" :key="data.id" :value="data.id">
                    <a-tooltip>
                      <template slot="title">
                        {{data.mtName}}
                      </template>
                      {{data.mtName}}
                    </a-tooltip>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表口径')">
                <a-select v-model="queryParam.mtCaliber" :placeholder="$t('请选择表口径')">
                  <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                    DN{{data.mtCaliber}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('运营商')">
                  <j-dict-select-tag v-model="queryParam.mtIotType" :placeholder="$t('请选择运营商')" dictCode="mtIotType" />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('IMEI号')">
                  <a-input :placeholder="$t('请输入IMEI号')" v-model="queryParam.mtImei"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('SIM卡号')">
                  <a-input :placeholder="$t('请输入SIM卡号')" v-model="queryParam.mtSim"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('册号')">
                  <a-input :placeholder="$t('请输入册号')" v-model="queryParam.mtVolumeNo"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('水表用途')">
                  <j-dict-select-tag v-model="queryParam.mtUseType" :placeholder="$t('请选择水表用途')" dictCode="mtUseType" />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('是否带阀')">
                  <j-dict-select-tag v-model="queryParam.mtHasValve" :placeholder="$t('请选择是否带阀')" dictCode="	yn" />
                </a-form-item>
              </a-col>
              <a-col :xl="12" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('创建时间')">
                  <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                    @change="onDateRangeChange"
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table ref="table" size="middle"  :bordered="false" rowKey="id" :columns="columns"
        :dataSource="dataSource" :pagination="ipagination" :loading="loading" :scroll="{ x: 'max-content' }" :customRow="customRow"
        :rowSelection="{ type: 'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange">
        <span slot="mtStateSlot" slot-scope="text, record">
          <StateNetwork :status="record.mtState"></StateNetwork>
        </span>
      </a-table>
    </j-modal>
  </j-modal>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import { mixinDevice } from '@/utils/mixin'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue,listSize
  } from '@/utils/util'
  import { isEmptyObject,isUndefinedAndNull,isUndefined } from '@/utils/validate'
  import {PhoneNumberPattern,CardIdNumberPattern} from '@/utils/regPattern'
import { assign } from 'xe-utils/methods'
import Detail from '@/views/engineeringInstallation/constructionManagement/modules/detail'
import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import JInput from '@/components/jeecg/JInput'
  export default {
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    name: 'putOnRecord',
    components:{
      Detail,
      DetailList,
      DetailListItem,
      JInput
    },
    data() {
      // 查询表编号是否重复
      let validateMeterId = (rule, value, callback) =>{
        getAction(this.url.queryByMeterId,{id:this.model.meterId}).then((res) => {
            if(res.success){
              callback()
            }else{
              callback(this.$t('该表编号不能使用!'))
            }
        })
      };
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          meterTypeList: "/jeecg-charge/meter/meterType/list",  //表类型请求地址
          userCaliberList: "/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
          addDocumentation: "/jeecg-engineering/engineering/installationDetail/addDocumentation",
          queryByMeterId: "/jeecg-charge/meter/meterinfo/queryByMeterId",
          userIdCreateRule: '/jeecg-charge/meter/departUserIdConfig/queryCurrentDepartUserIdRule',
          next: "/jeecg-engineering/flowable/task/completeByDateId",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          meterUserType: "/jeecg-charge/meter/meterUserType/list",
          queryById: "/jeecg-engineering/engineering/installationDetail/queryById",
          list:"/jeecg-charge/meter/meterinfo/list",
          
        },
        meterTypeList: [],  //表类型
        userCaliberList: [],  // 表口径
        modal2Visible: false,
        userTypeList: [],
        meterModalVisible:false,
        dataSource: [],
        meterInfo: {},
        queryParam:{
          mtState:0
        },
        searchAreaValue: ''
      }
    },
    computed: {
      title2() {
        return this.$t('请选择区域名称')
      },
      validatorRules() {
        return {
          audit:{ required: true,message: this.$t('请选择审批意见'), trigger: 'change' },
          remark1:{ required: !(this.model.audit == 1),message: this.$t('请输入备注'),trigger: 'input' },
          meterId: [{required:true, message: this.$t('请选择表编号!'),trigger: 'input'}],
          // meterId: [{required:true, pattern:/^[+]{0,1}(\d{14})$/, message: '请输入正确的表编号!'},{validator: validateMeterId}],
          mtCode: [{ required: true, message: this.$t('请选择表类型！') }],
          mtVolumeNo:[{ required: false, pattern: /^\d+$/, message: this.$t('请输入正确的册号!') }],
          mtCaliber:  [{ required: true, message: this.$t('请选择表口径！') }],
          mtState: [{ required: true, message: this.$t('请选择水表当前状态！') }],
          userAreaName: [{required:true, message:this.$t('请选择区域'),trigger:'change'}],
          userAddr: [{required:true, message:this.$t('请输入用户地址'),whitespace: true}],
          // meterId:[{required: true, message: '请输入表编号!',trigger:'blur'},{pattern: validateMeterId}],
          userId:[{required: true, message:this.$t('请输入用户编号'),whitespace: true},],
          userName:[{required:true, message:this.$t('请输入用户姓名'),whitespace: true}],
          userPhone:[{required:true , message:this.$t('请输入手机号码'),whitespace: true},{pattern: PhoneNumberPattern,message: this.$t('请输入正确的手机号码')}],
          userIdNumber:[{required:false ,pattern: CardIdNumberPattern,message: this.$t('请输入正确的身份证号'),whitespace: true}],
          userAreaId:[{required:true, message:this.$t('请输入用户区域id！'),whitespace: true}],
        }
      },
      // 表头
      columns() {
        return [{
            title:this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150
          },{
            title:this.$t('册号'),
            align:"center",
            dataIndex: 'mtVolumeNo',
            width: 150
          },{
            title:this.$t('建档状态'),
            align:"center",
            dataIndex: 'mtState',
            width: 150,
            scopedSlots: { customRender: 'mtStateSlot' },
          },{
            title:this.$t('表类型'),
            align:"center",
            dataIndex: 'mtName',
            width: 100
          },{
            title:this.$t('表口径'),
            align:"center",
            dataIndex: 'mtCaliber',
            customRender: (text,row) => {
              //字典值替换通用方法
              return 'DN'+text;
            },
            width: 80
          },{
            title:this.$t('运营商'),
            align:"center",
            dataIndex: 'mtIotType',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('mtIotType', text);
            },
            width: 80
          },{
            title:this.$t('水表用途'),
            align:"center",
            dataIndex: 'mtUseType',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('mtUseType', text);
            },
            width: 80
          },{
            title:this.$t('是否带阀'),
            align:"center",
            dataIndex: 'mtHasValve',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('yn', text);
            },
            width: 80
          },
          /*
          {
            title:'厂商代码',
            align:"center",
            dataIndex: 'mtComCode',
            width: 100
          },*/
          {
            title:this.$t('水表厂商'),
            align:"center",
            dataIndex: 'mtComName',
            width: 100
          },{
            title:this.$t('IMEI号'),
            align:"center",
            dataIndex: 'mtImei',
            width: 150,
            ellipsis: true,
          },{
            title:this.$t('SIM卡号'),
            align:"center",
            dataIndex: 'mtSim',
            width: 150,
            ellipsis: true,
          },{
            title:this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime',
            width: 120,
            ellipsis: true,
          },{
            title:this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy',
            width: 120,
            ellipsis: true,
          },
        ]
      },
    },
    watch:{
      searchAreaValue(val) {
        this.$refs.areaTree.filter(val);
        this.$nextTick(() => {
          this.changeTreeNodeStatus(this.$refs.areaTree.store.root);
        });
        
      },
      'model.audit':{
        handler(val){
          // remark1 必填规则已在 computed validatorRules 中根据 model.audit 动态计算
        }
      },
      // 'model.mtCode': {
      //   handler:function(newV,oldV){debugger
      //     let currentMeterTypeObj = {}
      //     for(let i =0;i<this.meterTypeList.length;i++) {
      //       if(this.meterTypeList[i].id == newV) {
      //         currentMeterTypeObj = this.meterTypeList[i];
      //         break;
      //       }
      //     }
      //     console.log(currentMeterTypeObj)
      //     if(!isEmptyObject(currentMeterTypeObj)) {
      //       if(currentMeterTypeObj.mtCode== 'Y18-N') {
      //         // 贝林水表
      //         this.validatorRules.meterId[0].pattern = /^[+]{0,1}(\d{10})$/
      //       }else if(currentMeterTypeObj.mtCode== 'Y17-N') {
      //         // 三川
      //         this.validatorRules.meterId[0].pattern = /^[+]{0,1}(\d{12})$/
      //       }else if(currentMeterTypeObj.mtCode== 'Y18-17') {
      //         // 贝林在三川
      //         this.rules.meterId[0].pattern = /^[+]{0,1}(\d{14})$/
      //         this.$set(this.model,'meterId','3378');
      //       }else{
      //         this.validatorRules.meterId[0].pattern = /^[+]{0,1}(\d{14})$/
      //       }
      //     }else{
      //       this.validatorRules.meterId[0].pattern = /^[+]{0,1}(\d{14})$/
      //     }
      //     if(this.model.meterId!==null&&this.model.meterId!=='') {
      //       this.$nextTick(()=> {
      //         this.$refs.form.validateField("meterId")
      //       })
      //     }
      //   }
      // }
    },
    methods: {
      changeTreeNodeStatus(node) {// 搜索tree后只展开到当前搜索一级
        node.expanded = false;
        for (let i = 0; i < node.childNodes.length; i++) {
          node.childNodes[i].expanded = false;
          if(node.childNodes[i].data.areaName.indexOf(this.searchAreaValue)>-1){
            // node.childNodes[i].expanded = true;
            // node.expanded = false;
          }
          if (node.childNodes[i].childNodes.length > 0) {
            node.expanded = true;
            // node.childNodes[i].expanded = true;
            this.changeTreeNodeStatus(node.childNodes[i]);
          }
        }
      },
      filterNode(value, data, node) {
        // if (!value) return true;
        // return data.areaName.indexOf(value) !== -1;
        let parentNode = node.parent // 父级node
        let labels = [node.label] // 当前node的名字
        let level = 1 // 层级
        while (level < node.level) {
            labels = [...labels, parentNode.label] // 当前node名字，父级node的名字
            parentNode = parentNode.parent
            level++
        }
        return labels.some(d => d.indexOf(value) !== -1)
      },
      setValue(type,value){
        if(value){
          return filterDictTextByCache(type,value);
        }
      },
      searchReset(){
        this.queryParam = {
          mtState:0
        }
        this.loadData();
      },
      setMeterInfo(){
        this.meterModalVisible = true;
      },
      customRow (record, index) {
        return {
          on:{
            click:(e)=>{
              this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
            }
          }
        }
      },
      handleOk1() {
        let meterInfo = this.dataSource.find(item => item.id == this.selectedRowKeys[0]);
        this.meterModalVisible = false;
        this.model = assign({},this.model,{
          mtComName:meterInfo.mtComName,
          mtCode:meterInfo.mtCode,
          mtVolumeNo:meterInfo.mtVolumeNo,
          mtCaliber:meterInfo.mtCaliber,
          mtUseType:meterInfo.mtUseType,
          mtIotType:meterInfo.mtIotType,
          mtImei:meterInfo.mtImei,
          mtSim:meterInfo.mtSim,
          mtHasValve:meterInfo.mtHasValve,
          meterId:meterInfo.meterId,
          mtCodeName:meterInfo.mtCodeName,
          mtName:meterInfo.mtName
        });
      },
      handleCancel1() {
        this.meterModalVisible = false;
      },
      getuserTypeList(){
        this.userTypeList = [];
        getAction(this.url.meterUserType).then(res=>{
          if(res.success){
            this.userTypeList = res.result.records;
          }
        })
      },
      setModalVisible(){
          this.loadTree()
          this.modal2Visible = true;
      },
      nodeClick(record,node,data) {
        // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
          this.currentNodeKey = record.id
          this.$refs.areaTree.setCheckedKeys([record.id])
          //this.$refs.areaTree.setCurrentKey(record.id)
          this.currSelected = Object.assign({}, record);
          // 有的接口是areaId有的接口是userAreaId，兼容两个都写
          this.$set(this.model,'userAreaName', this.currSelected.areaName);
          this.$set(this.model,'userAreaId', this.currSelected.value);
          this.modal2Visible = false
      },
      queryUserTypeList() {  //表类型请求
        let that = this;
        let params = { pageNo: 1, pageSize: 999 }
        getAction(that.url.meterTypeList, params).then((res) => {
          if (res.success) {
            that.meterTypeList = res.result.records;
          }
        })
      },
      queryUserCaliberList() {   //表口径请求
        let params = { pageNo: 1, pageSize: 999 }
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if (res.success) {
            this.userCaliberList = res.result.records;
          }
        })
      },
      init(row,bool){
        this.title = this.$t('建档');
        this.visible = true;
        this.model = {};
        // this.model.id = row.id;
        if(bool){
          this.model.dataId = row.id;
          this.model.installationId = row.ticketsForeignId;
        }else{
          this.model.dataId = row.ticketsId;
          this.model.installationId = row.id;
        }
        getAction(this.url.queryById,{id:this.model.installationId}).then(res=>{
          if(res.success){
            this.model = Object.assign({},this.model,{
              userAddr: res.result.waterAddress,
              userName: res.result.clientName,
              userPhone: res.result.phone,
              userIdNumber: res.result.identificationNumber,
              userTypeCode: res.result.clientType,
            })
          }
        });
        getAction(this.url.userIdCreateRule).then((res) => {
          if (res.success&&res.result!=null) {
              this.$set(this.model,'userId',res.result.userIdCreateCurrentComp);   
          }
        })
        this.queryUserTypeList();
        this.queryUserCaliberList();
        this.getuserTypeList();
        this.$nextTick(()=>{
          this.$refs.detailRef.init(row,bool);
        });
      },
      handleCancel() {
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            if(that.model.audit == 1){
              postAction(this.url.addDocumentation,this.model).then((res) => {
                if (res.success) {
                  let params = {
                    dataId: that.model.dataId,
                    values: {
                      dataId: that.model.dataId,
                    },
                    comment: that.model.remark1
                  }
                  postAction(this.url.next,params).then((res)=>{
                    if(res.success){
                      that.$message.success(this.$t('操作成功'));
                      that.$emit('ok');
                      this.visible = false;
                    }else{
                      that.$message.warning(this.$t("操作失败"));
                    }
                  }).finally(() => {
                    that.confirmLoading = false;
                  })
                } else {
                  that.$message.warning(res.message);
                }
              })
            }else{
              let params = {
                dataId: that.model.dataId,
                values: {
                  dataId: that.model.dataId,
                },
                comment: that.model.remark1
              }
              postAction(this.url.reject,params).then((res)=>{
                if(res.success){
                  that.$message.success(this.$t('操作成功'));
                  that.$emit('ok');
                  this.visible = false;
                }else{
                  that.$message.warning(this.$t("操作失败"));
                }
              })
            }
          }else{
            this.$message.warning(this.$t('存在必填内容未填！'))
          }
        })
      },
      
    }
  }
</script>
<style lang="less" scoped>
/deep/.detail-list .content {
    line-height: normal;
  }
</style>